module.exports = "/static/assets/5d8cc0ff0d1ea048583ee33e9fd1a248.png";